module.exports = __webpack_public_path__ + "img/host-icon.d984e0b7.png";